// import Seo from "@/components/Seo/Seo";
// import assest from "@/json/assest";
import assest from "../../json/assest";
// import Wrapper from "@/layout/wrapper/Wrapper";
import NOprofileImage from "../../public/assets/images/no-image.svg";
import Wrapper from "../../layout/wrapper/Wrapper";
import {
  Avatar,
  Backdrop,
  Box,
  Button,
  Grid,
  InputAdornment,
  List,
  ListItem,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  SelectChangeEvent,
  Snackbar,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
// import Image from "next/image";
import React, { useCallback, useMemo, useState } from "react";
// import styles from "@/styles/pages/editors.module.scss";
import styles from "../../styles/pages/editors.module.scss";
// const NotificationLeftFilter = React.lazy(
//   () => import("../../components/NotificationLeftFilter/NotificationLeftFilter")
// );

import NotificationLeftFilter from "../../components/NotificationLeftFilter/NotificationLeftFilter";

// import CustomSelect from "@/components/CustomSelect/CustomSelect";
// const SearchEditorCard = dynamic(
//   () => import("@/components/SearchEditorCard/SearchEditorCard"),
//   {
//     ssr: false,
//   }
// );
// import SearchBoldIcon from "@/ui/Icons/SearchBoldIcon";
// const AddNewEditorModal = React.lazy(import("../../ui/Modal/AddNewEditorModal"));

import AddNewEditorModal from "../../ui/Modal/AddNewEditorModal";

import NextArrow from "../../ui/Icons/NextArrow";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import styles1 from "../../styles/pages/copywritters.module.scss";
// const VideosummaryCard = React.lazy(
//   () => import("../../components/VideosummaryCard/VideosummaryCard")
// );

import VideosummaryCard from "../../components/VideosummaryCard/VideosummaryCard";

// const StatusSearch = React.lazy(
//   () => import("../../components/StatusSearch/StatusSearch")
// );
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient,
} from "react-query";

import {
  EditorCreateMutation,
  dateObjects,
} from "../../api/functions/editor.api";
import useNotiStack from "../../hooks/useNotistack";
import {
  filterDate,
  searchCopywriters,
  statusCopywriters,
  totalCopywriters,
} from "../../api/functions/copywriters.api";
import CustomSelectTwo from "../../components/CustomSelectTwo/CustomSelectTwo";
// import SearchCopywriterCard from "@/components/SearchCopywriterCard/SearchCopywriterCard";
import AddRadiusIcon from "../../ui/Icons/AddRadiusIcon";
import SearchBoldIcon from "../../ui/Icons/SearchBoldIcon";
import SearchCopywriterCard from "../../components/SearchCopywriterCard/SearchCopywriterCard";
import InfiniteScroll from "react-infinite-scroll-component";
// import SearchCopywriterCard from "../../components/SearchCopywriterCard/SearchCopywriterCard";
const countryData = [
  { name: "Afghanistan", code: "AF" },
  { name: "Åland Islands", code: "AX" },
  { name: "Albania", code: "AL" },
  { name: "Algeria", code: "DZ" },
  { name: "American Samoa", code: "AS" },
  { name: "AndorrA", code: "AD" },
  { name: "Angola", code: "AO" },
  { name: "Anguilla", code: "AI" },
  { name: "Antarctica", code: "AQ" },
  { name: "Antigua and Barbuda", code: "AG" },
  { name: "Argentina", code: "AR" },
  { name: "Armenia", code: "AM" },
  { name: "Aruba", code: "AW" },
  { name: "Australia", code: "AU" },
  { name: "Austria", code: "AT" },
  { name: "Azerbaijan", code: "AZ" },
  { name: "Bahamas", code: "BS" },
  { name: "Bahrain", code: "BH" },
  { name: "Bangladesh", code: "BD" },
  { name: "Barbados", code: "BB" },
  { name: "Belarus", code: "BY" },
  { name: "Belgium", code: "BE" },
  { name: "Belize", code: "BZ" },
  { name: "Benin", code: "BJ" },
  { name: "Bermuda", code: "BM" },
  { name: "Bhutan", code: "BT" },
  { name: "Bolivia", code: "BO" },
  { name: "Bosnia and Herzegovina", code: "BA" },
  { name: "Botswana", code: "BW" },
  { name: "Bouvet Island", code: "BV" },
  { name: "Brazil", code: "BR" },
  { name: "British Indian Ocean Territory", code: "IO" },
  { name: "Brunei Darussalam", code: "BN" },
  { name: "Bulgaria", code: "BG" },
  { name: "Burkina Faso", code: "BF" },
  { name: "Burundi", code: "BI" },
  { name: "Cambodia", code: "KH" },
  { name: "Cameroon", code: "CM" },
  { name: "Canada", code: "CA" },
  { name: "Cape Verde", code: "CV" },
  { name: "Cayman Islands", code: "KY" },
  { name: "Central African Republic", code: "CF" },
  { name: "Chad", code: "TD" },
  { name: "Chile", code: "CL" },
  { name: "China", code: "CN" },
  { name: "Christmas Island", code: "CX" },
  { name: "Cocos (Keeling) Islands", code: "CC" },
  { name: "Colombia", code: "CO" },
  { name: "Comoros", code: "KM" },
  { name: "Congo", code: "CG" },
  { name: "Congo, The Democratic Republic of the", code: "CD" },
  { name: "Cook Islands", code: "CK" },
  { name: "Costa Rica", code: "CR" },
  { name: "Cote D'Ivoire", code: "CI" },
  { name: "Croatia", code: "HR" },
  { name: "Cuba", code: "CU" },
  { name: "Cyprus", code: "CY" },
  { name: "Czech Republic", code: "CZ" },
  { name: "Denmark", code: "DK" },
  { name: "Djibouti", code: "DJ" },
  { name: "Dominica", code: "DM" },
  { name: "Dominican Republic", code: "DO" },
  { name: "Ecuador", code: "EC" },
  { name: "Egypt", code: "EG" },
  { name: "El Salvador", code: "SV" },
  { name: "Equatorial Guinea", code: "GQ" },
  { name: "Eritrea", code: "ER" },
  { name: "Estonia", code: "EE" },
  { name: "Ethiopia", code: "ET" },
  { name: "Falkland Islands (Malvinas)", code: "FK" },
  { name: "Faroe Islands", code: "FO" },
  { name: "Fiji", code: "FJ" },
  { name: "Finland", code: "FI" },
  { name: "France", code: "FR" },
  { name: "French Guiana", code: "GF" },
  { name: "French Polynesia", code: "PF" },
  { name: "French Southern Territories", code: "TF" },
  { name: "Gabon", code: "GA" },
  { name: "Gambia", code: "GM" },
  { name: "Georgia", code: "GE" },
  { name: "Germany", code: "DE" },
  { name: "Ghana", code: "GH" },
  { name: "Gibraltar", code: "GI" },
  { name: "Greece", code: "GR" },
  { name: "Greenland", code: "GL" },
  { name: "Grenada", code: "GD" },
  { name: "Guadeloupe", code: "GP" },
  { name: "Guam", code: "GU" },
  { name: "Guatemala", code: "GT" },
  { name: "Guernsey", code: "GG" },
  { name: "Guinea", code: "GN" },
  { name: "Guinea-Bissau", code: "GW" },
  { name: "Guyana", code: "GY" },
  { name: "Haiti", code: "HT" },
  { name: "Heard Island and Mcdonald Islands", code: "HM" },
  { name: "Holy See (Vatican City State)", code: "VA" },
  { name: "Honduras", code: "HN" },
  { name: "Hong Kong", code: "HK" },
  { name: "Hungary", code: "HU" },
  { name: "Iceland", code: "IS" },
  { name: "India", code: "IN" },
  { name: "Indonesia", code: "ID" },
  { name: "Iran, Islamic Republic Of", code: "IR" },
  { name: "Iraq", code: "IQ" },
  { name: "Ireland", code: "IE" },
  { name: "Isle of Man", code: "IM" },
  { name: "Israel", code: "IL" },
  { name: "Italy", code: "IT" },
  { name: "Jamaica", code: "JM" },
  { name: "Japan", code: "JP" },
  { name: "Jersey", code: "JE" },
  { name: "Jordan", code: "JO" },
  { name: "Kazakhstan", code: "KZ" },
  { name: "Kenya", code: "KE" },
  { name: "Kiribati", code: "KI" },
  { name: "Korea, Democratic People'S Republic of", code: "KP" },
  { name: "Korea, Republic of", code: "KR" },
  { name: "Kuwait", code: "KW" },
  { name: "Kyrgyzstan", code: "KG" },
  { name: "Lao People'S Democratic Republic", code: "LA" },
  { name: "Latvia", code: "LV" },
  { name: "Lebanon", code: "LB" },
  { name: "Lesotho", code: "LS" },
  { name: "Liberia", code: "LR" },
  { name: "Libyan Arab Jamahiriya", code: "LY" },
  { name: "Liechtenstein", code: "LI" },
  { name: "Lithuania", code: "LT" },
  { name: "Luxembourg", code: "LU" },
  { name: "Macao", code: "MO" },
  { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
  { name: "Madagascar", code: "MG" },
  { name: "Malawi", code: "MW" },
  { name: "Malaysia", code: "MY" },
  { name: "Maldives", code: "MV" },
  { name: "Mali", code: "ML" },
  { name: "Malta", code: "MT" },
  { name: "Marshall Islands", code: "MH" },
  { name: "Martinique", code: "MQ" },
  { name: "Mauritania", code: "MR" },
  { name: "Mauritius", code: "MU" },
  { name: "Mayotte", code: "YT" },
  { name: "Mexico", code: "MX" },
  { name: "Micronesia, Federated States of", code: "FM" },
  { name: "Moldova, Republic of", code: "MD" },
  { name: "Monaco", code: "MC" },
  { name: "Mongolia", code: "MN" },
  { name: "Montserrat", code: "MS" },
  { name: "Morocco", code: "MA" },
  { name: "Mozambique", code: "MZ" },
  { name: "Myanmar", code: "MM" },
  { name: "Namibia", code: "NA" },
  { name: "Nauru", code: "NR" },
  { name: "Nepal", code: "NP" },
  { name: "Netherlands", code: "NL" },
  { name: "Netherlands Antilles", code: "AN" },
  { name: "New Caledonia", code: "NC" },
  { name: "New Zealand", code: "NZ" },
  { name: "Nicaragua", code: "NI" },
  { name: "Niger", code: "NE" },
  { name: "Nigeria", code: "NG" },
  { name: "Niue", code: "NU" },
  { name: "Norfolk Island", code: "NF" },
  { name: "Northern Mariana Islands", code: "MP" },
  { name: "Norway", code: "NO" },
  { name: "Oman", code: "OM" },
  { name: "Pakistan", code: "PK" },
  { name: "Palau", code: "PW" },
  { name: "Palestinian Territory, Occupied", code: "PS" },
  { name: "Panama", code: "PA" },
  { name: "Papua New Guinea", code: "PG" },
  { name: "Paraguay", code: "PY" },
  { name: "Peru", code: "PE" },
  { name: "Philippines", code: "PH" },
  { name: "Pitcairn", code: "PN" },
  { name: "Poland", code: "PL" },
  { name: "Portugal", code: "PT" },
  { name: "Puerto Rico", code: "PR" },
  { name: "Qatar", code: "QA" },
  { name: "Reunion", code: "RE" },
  { name: "Romania", code: "RO" },
  { name: "Russian Federation", code: "RU" },
  { name: "RWANDA", code: "RW" },
  { name: "Saint Helena", code: "SH" },
  { name: "Saint Kitts and Nevis", code: "KN" },
  { name: "Saint Lucia", code: "LC" },
  { name: "Saint Pierre and Miquelon", code: "PM" },
  { name: "Saint Vincent and the Grenadines", code: "VC" },
  { name: "Samoa", code: "WS" },
  { name: "San Marino", code: "SM" },
  { name: "Sao Tome and Principe", code: "ST" },
  { name: "Saudi Arabia", code: "SA" },
  { name: "Senegal", code: "SN" },
  { name: "Serbia and Montenegro", code: "CS" },
  { name: "Seychelles", code: "SC" },
  { name: "Sierra Leone", code: "SL" },
  { name: "Singapore", code: "SG" },
  { name: "Slovakia", code: "SK" },
  { name: "Slovenia", code: "SI" },
  { name: "Solomon Islands", code: "SB" },
  { name: "Somalia", code: "SO" },
  { name: "South Africa", code: "ZA" },
  { name: "South Georgia and the South Sandwich Islands", code: "GS" },
  { name: "Spain", code: "ES" },
  { name: "Sri Lanka", code: "LK" },
  { name: "Sudan", code: "SD" },
  { name: "Suriname", code: "SR" },
  { name: "Svalbard and Jan Mayen", code: "SJ" },
  { name: "Swaziland", code: "SZ" },
  { name: "Sweden", code: "SE" },
  { name: "Switzerland", code: "CH" },
  { name: "Syrian Arab Republic", code: "SY" },
  { name: "Taiwan, Province of China", code: "TW" },
  { name: "Tajikistan", code: "TJ" },
  { name: "Tanzania, United Republic of", code: "TZ" },
  { name: "Thailand", code: "TH" },
  { name: "Timor-Leste", code: "TL" },
  { name: "Togo", code: "TG" },
  { name: "Tokelau", code: "TK" },
  { name: "Tonga", code: "TO" },
  { name: "Trinidad and Tobago", code: "TT" },
  { name: "Tunisia", code: "TN" },
  { name: "Turkey", code: "TR" },
  { name: "Turkmenistan", code: "TM" },
  { name: "Turks and Caicos Islands", code: "TC" },
  { name: "Tuvalu", code: "TV" },
  { name: "Uganda", code: "UG" },
  { name: "Ukraine", code: "UA" },
  { name: "United Arab Emirates", code: "AE" },
  { name: "United Kingdom", code: "GB" },
  { name: "United States", code: "US" },
  { name: "United States Minor Outlying Islands", code: "UM" },
  { name: "Uruguay", code: "UY" },
  { name: "Uzbekistan", code: "UZ" },
  { name: "Vanuatu", code: "VU" },
  { name: "Venezuela", code: "VE" },
  { name: "Viet Nam", code: "VN" },
  { name: "Virgin Islands, British", code: "VG" },
  { name: "Virgin Islands, U.S.", code: "VI" },
  { name: "Wallis and Futuna", code: "WF" },
  { name: "Western Sahara", code: "EH" },
  { name: "Yemen", code: "YE" },
  { name: "Zambia", code: "ZM" },
  { name: "Zimbabwe", code: "ZW" },
];

const schema = yup.object({
  first_name: yup.string().required("First name is required").min(2),
  last_name: yup.string().required("Last name is required").min(2),
  address: yup.string().required("Address is required"),
  city: yup.string().required("City is required"),
  zip_code: yup.string().max(7).required("Zip code is required"),
  state: yup.string().required("State is required"),
  mobile: yup
    .string()
    .required("Phone number is required")
    .min(8, "Phone number must be at least 8 characters")
    .max(15, "Phone number must be at most 15 characters"),

  email: yup.string().email("Insert a valid email"),
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}
schema;

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const listItemLoop = [
  {
    listName: "Titled videos",
    videoCount: "580",
  },
  {
    listName: "Videos pending titles",
    videoCount: "420",
  },
];

const index = () => {
  const [status, setStatus] = React.useState("");
  console.warn("🚀 ~ file: index.jsx:412 ~ index ~ status:", status);
  const [search, setSearch] = React.useState("");
  const { toastError } = useNotiStack();
  const [profile, setProfile] = React.useState(null);
  const [date, setDate] = useState({
    startDate: "",
    endDate: "",
    type: "",
    search: "",
    status: "",
  });
  const [imageUploaded, setImageUploaded] = useState(false);

  const removeprofileImage = () => {
    setProfile(null);
    setImageUploaded(false);
  };
  const handleChange1 = (event) => {
    setStatus(event.target.value);
  };
  const uploadImage = (e) => {
    console.warn(e.target, "image");
    if (
      e.target.files[0]?.type === "image/jpeg" ||
      e.target.files[0]?.type === "image/png" ||
      e.target.files[0]?.type === "image/jpg"
    ) {
      if (e.target.files[0]?.size <= 300000) {
        setProfile(e.target.files[0]);
        setImageUploaded(true);
      } else {
        toastError("Please upload image of proper size.");
      }
    } else {
      toastError("Please upload image of proper format.");
    }
  };
  const [status1, setStatus1] = React.useState("");

  //   const [search, setSearch] = React.useState("");
  const searchChange1 = (event) => {
    // setStatus1(event.target.value);
    setDate({ ...date, status: event.target.value });
  };
  const searchChange2 = (event) => {
    // setSearch(event.target.value);
    setDate({ ...date, search: event.target.value });
  };
  const [openNewEditorModal, setOpenNewEditorModal] = React.useState(false);

  const handleOpenNewEditorModal = useCallback(() => {
    setOpenNewEditorModal(true);
  }, []);

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [Country, setCountry] = React.useState("");

  const handleChange2 = (event) => {
    setCountry(event.target.value);
  };

  const [snackOpen, setSnackOpen] = React.useState(false);
  const { mutate } = useMutation(EditorCreateMutation);

  const handleClick = () => {
    setValue(1);
  };

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackOpen(false);
    setOpenNewEditorModal(false);
  };

  const handleCloseNewEditorModal = useCallback(() => {
    reset({
      first_name: "",
      last_name: "",
      address: "",
      city: "",
      zip_code: "",
      state: "",
      mobile: "",
      email: "",
    });
    setProfile(null);
    setOpenNewEditorModal(false);
  }, []);
  const getDateFromChild = (data) => {
    setDate(data);
  };
  // console.warn(date)
  const statusSearch = (data) => {
    console.warn(data, "vvvvv");
    if (data.status !== "") {
      setStatus(data.status);
      setSearch("");
    }
    if (data.search !== "") {
      setSearch(data.search);
      setStatus("");
    }
  };
  const empty = () => {
    setDate({ startDate: "", endDate: "", type: "" });
    // setStatus("")
  };

  const empty2 = () => {
    setStatus1("");
  };

  // const { data, isLoading } = useQuery(
  //   ["copywritersData", , search, status1, date],
  //   async () => {
  //     if (search.length >= 1) {
  //       empty();
  //       empty2();
  //       return searchCopywriters(search);
  //     } else if (date.startDate !== "" && date.endDate !== "") {
  //       empty2();
  //       return filterDate(date);
  //     } else if (status1 === 1 || status1 === 0) {
  //       // empty()
  //       return statusCopywriters(status1);
  //     } else {
  //       return totalCopywriters();
  //     }
  //   }
  // );

  const { data, fetchNextPage, hasNextPage, refetch, isLoading } =
    useInfiniteQuery({
      queryKey: ["copywritersData", search, status1, date],
      queryFn: ({ pageParam = 1 }) => {
        return totalCopywriters(pageParam, date);
      },
      keepPreviousData: true,

      enabled: true,

      getNextPageParam: (lastPage, allPages) => {
        if (
          allPages[allPages.length - 1 || 0].current_page <
          allPages[0]?.last_page
        ) {
          console.warn(allPages[0].current_page + 1, "sdadasdas");
          // Assuming lastPage.length represents the number of items on the current page
          // You may need to adjust this logic based on your API response structure
          return allPages[allPages.length - 1 || 0].current_page + 1;
        } else {
          return undefined;
        }
      },
    });

  const processed_data = useMemo(() => {
    var dat = { data: [] };
    data?.pages?.forEach((item) => {
      dat = { ...item, data: [...dat.data, ...item.data] };
    });
    return dat;
  }, [data]);
  console.warn(
    "🚀 ~ file: index.jsx:590 ~ constprocessed_data=useMemo ~ processed_data:",
    processed_data
  );
  const queryClient = useQueryClient();
  const [selectedId, setfirst] = useState("");
  const handleClickasdsa = (id) => {
    setfirst(id);
  };
  const handleClick2 = (data) => {
    let formData = new FormData();
    formData.append("name", data.first_name);
    formData.append("last_name", data.last_name);
    formData.append("role_id", 5);
    formData.append("address", data.address);
    formData.append("city", data.city);
    formData.append("state", data.state);
    formData.append("zip_code", data.zip_code);
    formData.append("mobile", data.mobile);
    formData.append("email", data.email);
    formData.append("country", Country);
    {
      profile == null ? "" : formData.append("image", profile);
    }
    mutate(formData, {
      onSuccess: (data) => {
        if (data?.message === "User added successfully") {
          setOpenNewEditorModal(false);
          setSnackOpen(true);
          queryClient.invalidateQueries([
            "copywritersData",
            search,
            status1,
            date,
          ]);
        }
      },
      onError: (err) => {
        console.warn(err);
      },
    });
  };
  return (
    <Wrapper>
      {/* <Seo
        title="Copywritters"
        canonical={""}
        description={""}
        url={""}
        image={""}
      /> */}
      <Box className="main_body">
        {/* ======================================= */}
        {/* ========= FOR NOT FOUND START ========= */}
        {processed_data?.data.length < 0 ? (
          <Stack
            alignItems={"center"}
            justifyContent={"center"}
            className={styles.editorNoitem}
          >
            <figure>
              <img
                src={assest.CopywritterNoitem}
                width={120}
                height={124}
                alt="icon"
              />
            </figure>
            <Typography variant="body1">
              No copywriters have been added yet.
            </Typography>
            <Button
              startIcon={<AddRadiusIcon />}
              className={`${styles.addeditorBtn} ${styles1.addcopywritterBtn}`}
              onClick={() => handleOpenNewEditorModal()}
            >
              Add a Copywriter
            </Button>
          </Stack>
        ) : (
          <Box className={`${styles.editorBody} ${styles.bodyScroll}`}>
            <PerfectScrollbar>
              <Stack
                direction={"row"}
                justifyContent={"space-between"}
                flexWrap={"wrap"}
                className={styles.bttmGap}
              >
                <Box
                  className={`${styles.SecFilter} ${styles.editorSecFilter}`}
                >
                  <NotificationLeftFilter
                    filterType={"copywriter"}
                    getDataFromChild={getDateFromChild}
                  />
                </Box>
                <Box className={styles.searchStatus}>
                  <Box className={styles.innerSearch}>
                    {/* <StatusSearch
                      getStatusSearchData={statusSearch}
                      empty={empty}
                    /> */}

                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      flexWrap={"wrap"}
                      justifyContent={"space-between"}
                      className={styles.formcontrolSearch}
                    >
                      <TextField
                        label=""
                        id="outlined-size-normal"
                        placeholder="Search..."
                        onChange={searchChange2}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchBoldIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                      <CustomSelectTwo
                        value={date.status}
                        onChange={searchChange1}
                        // onClick={() => empty()}
                        displayEmpty
                      >
                        <MenuItem value={""}>All Statues</MenuItem>
                        <MenuItem value={1}>Active</MenuItem>
                        <MenuItem value={0}>Inactive</MenuItem>
                      </CustomSelectTwo>
                    </Stack>

                    <InfiniteScroll
                      className={styles.infiniteScroll}
                      dataLength={
                        // !!data &&
                        // !!data.pages &&
                        // data.pages.length > 0 &&
                        processed_data?.data?.length
                      }
                      next={fetchNextPage}
                      height={`calc(100vh - 189px)`}
                      hasMore={hasNextPage}
                      loader={<h4>Loading...</h4>}
                    >
                      {isLoading ? (
                        <Backdrop
                          sx={{
                            color: "#fff",
                            zIndex: (theme) => theme.zIndex.drawer + 1,
                          }}
                          open={isLoading}
                          onClick={handleClose}
                          className="loader"
                        >
                          <div className="loader-wrapper">
                            <div className="loaderIcon">
                              <img
                                src={assest.logo_loader}
                                alt="img"
                                width={100}
                                height={100}
                              />
                            </div>
                          </div>
                        </Backdrop>
                      ) : (
                        <Box
                          className={`${styles.editorCardList} ${styles.styledECList}`}
                        >
                          {processed_data?.data.length !== 0 ? (
                            <>
                              {processed_data?.data?.map((item, index) => {
                                return (
                                  <SearchCopywriterCard
                                    totaldata={item}
                                    key={index}
                                    avatar={item?.avatar}
                                    name={item?.name}
                                    editorDate={item?.editorDate}
                                    email={item?.email}
                                    totalVideo={item?.titled_videos_count}
                                    sinceTitle={item?.sinceTitle}
                                    cardType={"for_copywriter"}
                                    type={item?.status}
                                    videoFor={"Total titled"}
                                    assignAccount={false}
                                    assignNo={""}
                                    id={item.id}
                                    fullitem={item}
                                    selectedId={selectedId}
                                    isLoading={isLoading}
                                    onClick={() => {
                                      handleClickasdsa(item.id);
                                      // setName(item.name),
                                      // setRoleId(item?.role_id);
                                    }}
                                  />
                                );
                              })}
                            </>
                          ) : (
                            ""
                          )}
                        </Box>
                      )}
                    </InfiniteScroll>
                  </Box>
                </Box>
                <Box className={styles.addEditor}>
                  <Box className={styles.editorInnerWrap}>
                    <Button
                      startIcon={<AddRadiusIcon />}
                      className={styles.addeditorBtn}
                      onClick={() => handleOpenNewEditorModal()}
                    >
                      Add new COPYWRITER
                    </Button>
                    <VideosummaryCard
                      videoTitle={"Video Titling Summary"}
                      countVideo={""}
                    >
                      <List>
                        {listItemLoop.map((item, index) => {
                          return (
                            <ListItem>
                              <Typography variant="body1">
                                {item?.listName}
                              </Typography>

                              <Typography variant="caption">
                                {item?.videoCount}
                              </Typography>
                            </ListItem>
                          );
                        })}
                      </List>
                    </VideosummaryCard>
                  </Box>
                </Box>
              </Stack>
            </PerfectScrollbar>
          </Box>
        )}

        {/* ======================================= */}
        {/* ========== FOR NOT FOUND END ========== */}

        {/* ================================ */}
        {/* ========= EDITOR MODAL ========= */}

        <AddNewEditorModal
          open={openNewEditorModal}
          onClose={handleCloseNewEditorModal}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            flexWrap="wrap"
            className={styles.modalHeading}
          >
            <Typography variant="h3">Add new COPYWRITER</Typography>
            <Button onClick={handleCloseNewEditorModal}>
              <img src={assest.crossGray} width={13} height={13} alt="icon" />
            </Button>
          </Stack>
          <Stack className={styles.tabsButtonCenter}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab label="Personal Details" {...a11yProps(0)} />
              <Tab label="Account Setup" {...a11yProps(1)} />
            </Tabs>
          </Stack>
          <Box className={styles.innerPanel}>
            <TabPanel value={value} index={0}>
              <PerfectScrollbar>
                <Box className={styles.accountFormGroup}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    flexWrap="wrap"
                    className={styles.labelStack}
                  >
                    <Typography variant="caption">Full name</Typography>
                  </Stack>
                  <Box className={styles.gridWrap}>
                    <Grid
                      container
                      rowSpacing={3}
                      columnSpacing={{ xs: 1, sm: 2, md: 5.75 }}
                    >
                      <Grid item md={4.02}>
                        <Box
                          className={`${styles.formGroup} ${styles.formGroup200}`}
                        >
                          <label>First Name</label>
                          <OutlinedInput
                            type="text"
                            placeholder={""}
                            {...register("first_name")}
                          />
                          {errors.first_name && (
                            <span style={{ color: "red", fontSize: "15px" }}>
                              {errors.first_name.message}
                            </span>
                          )}
                        </Box>
                      </Grid>
                      <Grid item md={4.02}>
                        <Box
                          className={`${styles.formGroup} ${styles.formGroup200}`}
                        >
                          <label>Last name</label>
                          <OutlinedInput
                            type="text"
                            placeholder={""}
                            {...register("last_name")}
                          />
                          {errors.last_name && (
                            <span style={{ color: "red", fontSize: "15px" }}>
                              {errors.last_name.message}
                            </span>
                          )}
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
                <Box
                  className={`${styles.accountFormGroup} ${styles.accountPhysiAdd}`}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    flexWrap="wrap"
                    className={styles.labelStack}
                  >
                    <Typography variant="caption">Physical Address</Typography>
                  </Stack>
                  <Box className={styles.gridWrap}>
                    <Box className={styles.forAddress}>
                      <Grid
                        container
                        rowSpacing={3}
                        columnSpacing={{ xs: 1, sm: 2, md: 5.75 }}
                      >
                        <Grid item md={6.8}>
                          <Box className={styles.formGroup}>
                            <label>Address</label>
                            <OutlinedInput
                              type="text"
                              placeholder={""}
                              {...register("address")}
                            />
                            {errors.address && (
                              <span style={{ color: "red", fontSize: "15px" }}>
                                {errors.address.message}
                              </span>
                            )}
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                    <Grid
                      container
                      rowSpacing={3.3}
                      columnSpacing={{ xs: 1, sm: 2, md: 5.75 }}
                    >
                      <Grid item md={3.4}>
                        <Box className={styles.formGroup}>
                          <label>City</label>
                          <OutlinedInput
                            type="text"
                            placeholder={""}
                            {...register("city")}
                          />
                          {errors.city && (
                            <span style={{ color: "red", fontSize: "15px" }}>
                              {errors.city.message}
                            </span>
                          )}
                        </Box>
                      </Grid>
                      <Grid item md={3.4}>
                        <Box className={styles.formGroup}>
                          <label>State</label>
                          <OutlinedInput
                            type="text"
                            placeholder={""}
                            {...register("state")}
                          />
                          {errors.state && (
                            <span style={{ color: "red", fontSize: "15px" }}>
                              {errors.state.message}
                            </span>
                          )}
                        </Box>
                      </Grid>
                      <Grid item md={2.34}>
                        <Box className={styles.formGroup}>
                          <label>Zip Code</label>
                          <OutlinedInput
                            type="text"
                            placeholder={""}
                            {...register("zip_code")}
                          />
                          {errors.zip_code && (
                            <span style={{ color: "red", fontSize: "15px" }}>
                              {errors.zip_code?.message}
                            </span>
                          )}
                        </Box>
                      </Grid>
                      <Grid item md={4.02}>
                        {/* <Box
                          className={`${styles.formGroup} ${styles.formGroup200}`}
                        >
                          <label>Country</label>
                          <Select
                            value={country}
                            onChange={handleChange2}
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                            >
                            <MenuItem value="">Select Country</MenuItem>
                            <MenuItem value="United Arab Emirates">
                              United Arab Emirates
                            </MenuItem>
                            <MenuItem value="United Arab Emirates">
                              United Arab Emirates
                            </MenuItem>
                            <MenuItem value="United Arab Emirates">
                              United Arab Emirates
                            </MenuItem>
                          </Select>
                        </Box> */}

                        <Controller
                          name="country"
                          control={control}
                          render={({
                            field: { onChange, value },
                            fieldState: { invalid },
                          }) => (
                            <Box
                              className={`${styles.formGroup} ${styles.formGroup200}`}
                            >
                              <label>Country</label>
                              <Select
                                // disabled={dis1}
                                value={Country}
                                // onChange={handleChange2}
                                onChange={(Country) => handleChange2(Country)}
                                displayEmpty
                                inputProps={{ "aria-label": "Without label" }}
                              >
                                <MenuItem value="">Select country</MenuItem>

                                {countryData.map((Data) => (
                                  <MenuItem value={Data.name}>
                                    {Data.name}({Data.code})
                                  </MenuItem>
                                ))}
                              </Select>
                            </Box>
                          )}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
                <Box
                  className={`${styles.accountFormGroup} ${styles.accountPhno}`}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    flexWrap="wrap"
                    className={styles.labelStack}
                  >
                    <Typography variant="caption">Phone Number</Typography>
                  </Stack>
                  <Box className={styles.gridWrap}>
                    <Grid
                      container
                      rowSpacing={3}
                      columnSpacing={{ xs: 1, sm: 2, md: 5.75 }}
                    >
                      <Grid item md={4.02}>
                        <Box
                          className={`${styles.formGroup} ${styles.formGroup200}`}
                        >
                          {/* <label>Mobile</label> */}
                          <OutlinedInput
                            type="number"
                            placeholder={""}
                            {...register("mobile")}
                          />
                          {errors.mobile && (
                            <p style={{ color: "red", fontSize: "15px" }}>
                              {errors.mobile?.message}
                            </p>
                          )}
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </PerfectScrollbar>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <PerfectScrollbar>
                <Box className={styles.accountSettingWrapper}>
                  <Box className={styles.forProfilePic}>
                    <Stack
                      direction="row"
                      alignItems="center"
                      flexWrap="wrap"
                      className={styles.labelStack}
                    >
                      <Typography variant="caption">Profile Picture</Typography>
                    </Stack>
                    <Stack
                      direction="row"
                      alignItems="center"
                      flexWrap="wrap"
                      className={styles.profileSec}
                    >
                      {profile == null ? (
                        <Avatar
                          alt="Remy Sharp"
                          src={NOprofileImage}
                          sx={{ width: 97, height: 97 }}
                        />
                      ) : (
                        <Avatar
                          alt="Remy Sharp"
                          src={URL.createObjectURL(profile)}
                          sx={{ width: 97, height: 97 }}
                        />
                      )}

                      <List>
                        {imageUploaded ? (
                          <ListItem>
                            <Button
                              className={styles.removeBtn}
                              onClick={removeprofileImage}
                            >
                              remove it
                            </Button>
                          </ListItem>
                        ) : (
                          <ListItem className={styles.customUploadFile}>
                            <input
                              type="file"
                              id="upload"
                              hidden
                              onChange={uploadImage}
                            />
                            <label htmlFor="upload">Update picture</label>
                          </ListItem>
                        )}
                      </List>
                    </Stack>
                  </Box>
                  <Box className={styles.forEmail}>
                    <Box className={styles.gridWrap}>
                      <Grid
                        container
                        rowSpacing={3}
                        columnSpacing={{ xs: 1, sm: 2, md: 5.75 }}
                      >
                        <Grid item md={6.34}>
                          <Box
                            className={`${styles.formGroup} ${styles.formGroup200}`}
                          >
                            <label>Email address</label>
                            <OutlinedInput
                              type="email"
                              // placeholder={"email"}
                              {...register("email")}
                            />
                            {errors.email ? (
                              <span
                                style={{
                                  color: "red",
                                  fontSize: "15px",
                                }}
                              >
                                {errors.email.message}
                              </span>
                            ) : (
                              ""
                            )}
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                </Box>
              </PerfectScrollbar>
            </TabPanel>
          </Box>
          {value === 0 ? (
            <Box className={styles.nextBtn} onClick={handleSubmit(handleClick)}>
              <Button endIcon={<NextArrow />}>NEXT</Button>
            </Box>
          ) : (
            <Box
              className={styles.nextBtn}
              onClick={handleSubmit(handleClick2)}
            >
              <Button endIcon={<NextArrow />}>CREATE</Button>
            </Box>
          )}
        </AddNewEditorModal>

        <Backdrop
          open={snackOpen || openNewEditorModal}
          onClick={handleClose}
          sx={{ zIndex: "111" }}
          className={styles.snackBackDrop}
        >
          <Snackbar
            open={snackOpen}
            autoHideDuration={3000}
            onClose={handleClose}
            message={`Invitation Sent Successfully`}
            ContentProps={{
              sx: {
                justifyContent: "center",
                minWidth: "246px !important",
                background: "#000",
                boxShadow: "0px 0px 3px 1px rgba(0, 0, 0, 0.5)",
                height: "45px",
                padding: 0,
                "& .MuiSnackbarContent-message": {
                  fontWeight: "500",
                  fontSize: "13px",
                },
              },
            }}
          />
        </Backdrop>
      </Box>
    </Wrapper>
  );
};

export default index;
